import { getImageURL, getPricingImageURL, getB2bmyaccountFedURL, } from '../utils/GeneralUtil';
// const imagePrefixURL = (str: string) => getPricingImageURL(str); // use for PROD
var imagePrefixURL = function (str) { return getB2bmyaccountFedURL(str); }; // use until added to https://assets.thdstatic.com/images/v1/loyaltyBenefits/PricingBenefits/
// Assets, Images
export var assetsPricing = {
    dollarLogo: getImageURL("icon-PreferredPricing-NoBoarder.svg"),
    desktopNonProXtraPricingIntro: getPricingImageURL("pricing-banner-desktop-nonpreferred.jpg"),
    desktopProXtraPricingIntro: getPricingImageURL("pricing-banner-desktop-preferred.jpg"),
    tabletProXtraPricingIntro: getPricingImageURL("pricing-banner-tablet.jpg"),
    mobileProXtraPricingIntro: getPricingImageURL("pricing-banner-mobile.jpg"),
    // General Buttons
    caretRightDark: getImageURL("caret-right_dark.svg"),
    removeCloseOrange: getImageURL("remove-close_orange.svg"),
    // Video play button (overlays)
    iconVideoPlayLight: getPricingImageURL("Icon-video-play_light.svg"),
    iconVideoPlayDark: getPricingImageURL("Icon-video-play_dark.svg"),
    videoPreferredPricingWithButton: getPricingImageURL("video_preferred-pricing.svg"),
    // MW - HowDoesItWork background
    bgBrownGradient: getPricingImageURL("bg-brownGradient.svg"),
    photoVirtualIdScan: getPricingImageURL("photo-virtual-ID-scan.jpg"),
    // Modal
    hdiwShopInStore: getPricingImageURL("graphic-HDIW-shopInstore.svg"),
    hdiwShopOnline: getPricingImageURL("graphic-HDIW-shopOnline.svg"),
    hdiwPlaceholder: getPricingImageURL("graphic-HIW-placeholder.svg"),
    hdiwScanId: getPricingImageURL("graphic-HIW-scanId.svg"),
    // From: proConstants.tsx
    ShopMore: getPricingImageURL("graphic-HIW-placeholder.svg"),
    // ShopMore: imagePrefixURL(`graphic-HIW-placeholder-graphic-HIW-shopMore@2x.png`,),
    ModalDesktop: imagePrefixURL("Desktop@2x.png"),
    mobileList: imagePrefixURL("GraphicHiwFindSavings.png"),
    mobileList1: getPricingImageURL("graphic-HIW-scanId.svg"),
    ScanHiw: getPricingImageURL("graphic-HIW-scanId.svg"),
    // mobileList1: imagePrefixURL(`@2xGraphicHiwScanId-GraphicHiwPanel1Copy3.png`),
    // ScanHiw: imagePrefixURL(`graphic-HIW-placeholder-GraphicHiwScanId@2x.png`),
    proXtraPreferredD: imagePrefixURL("videoModel.png"),
    VideoLogo: getPricingImageURL("Icon-video-play_dark.svg"),
    // From: HowDoesWorkModal.tsx
    // Locked: (props: any) => <>{imagePrefixURL(`PerksLockedIcon.svg`)}</>,
    // OrangeUnlocked: (props: any) => <>{imagePrefixURL(`badge-unlocked.svg`)}</>,
    // Locked: imagePrefixURL(`PerksLockedIcon.svg`),
    // OrangeUnlocked: imagePrefixURL(`badge-unlocked.svg`),
    Locked: getImageURL("reward-locked-black.svg"),
    OrangeUnlocked: getImageURL("rewards-unlocked-orange.svg"),
    CloseIcon: getImageURL("remove-close_orange.svg"),
    // dollarLogo: imagePrefixURL(`dollarLogo.png`),
    // From: HowDoesWorkModal.tsx
    NextArrow: getImageURL("caret-right_dark.svg"),
    NextArrowOrange: getImageURL("/ProTiers/chevron-brand-right.svg"),
    // NextArrow: imagePrefixURL(`next-arrow-orange.svg`),
    mobileHowDoesWork: imagePrefixURL("banner-bg-HowItWorks.png"),
    // VideoLogowhite: imagePrefixURL(`videoLogowhote.png`),
    VideoLogowhite: getPricingImageURL("Icon-video-play_light.svg"),
    // From: PreferredPricingBanner.tsx
    // PrefPricingTier1: imagePrefixURL(`preferred-pricing-badge.png`), // TODO: Need import
    PrefPricingTier1: getImageURL("PrgDetails/icon-PreferredPricing@2x.png"),
    PrefPricingTier0: imagePrefixURL("graphic-PrefPricing-Tier0.svg"),
    // From: ProXtraLearn.tsx
    // tabletProXtraPricingIntro: imagePrefixURL(`@2xPhotoVirtualIdScan.png`),
    learnIconList: imagePrefixURL("graphic-ProductRow@2x.png"),
    // From: ProXtraPreferredBanner.tsx
    proXtraPreferredTablet: imagePrefixURL("sectionheaderimage2xTablet.png"),
};
// Text
export var pbSavings = {
    proSavingDescription: "   With a full line-up of cost saving programs just for pros, Pro Xtra  can help your business stay ahead. Check out your opportunities to save below.",
    proSavingHeading: "Pro Xtra Savings",
};
export var pbSpendSummary = {
    spendIncludes: "Pro Xtra Spend includes transactions made with Pro Xtra ID or registered tender. Excludes taxes, shipping fees, returns, and gift card purchases.",
    spendIncludesLoyalty: "Pro Xtra Loyalty Spend includes transactions made with Pro Xtra ID or registered tender. Excludes taxes, shipping fees, returns, and gift card purchases.",
    savingIncludes: "Savings includes amount saved from discounts on full price product, other markdowns, bulk discounts, and Pro Xtra exclusive savings.",
    fullDetails: "For full details, see the",
    proXtraSpend: "Pro Xtra Spend",
    proXtraLoyaltySpend: "Pro Xtra Loyalty Spend",
    saving: "Savings",
    proXtraSummary: "Pro Xtra Summary",
};
export var pbPreferredPricing = {
    watchButton: "Watch Video",
    modalHowItWork: "Preferred Pricing: How Does It Work?",
    modalEasyTitle: "It's easy to save with Preferred Pricing.",
    pricingVideo: {
        '720p': "https://assets.thdstatic.com/mobile-apps/videos/pro/pricing/pro_xtra_preferred_pricing_2023_720p.mp4",
        '1080p': "https://assets.thdstatic.com/mobile-apps/videos/pro/pricing/pro_xtra_preferred_pricing_2023_1080p.mp4",
        '720p-old': "https://assets.thdstatic.com/mobile-apps/videos/pro/pricing/pro_xtra_preferred_pricing_720p.mp4",
    },
    PrefPricingBanner: {
        unqualified: {
            title: "Ready for Even More Savings, Pro Xtra Member?",
            content: "When you reach the Elite tier, you'll unlock Preferred Pricing and save even more on the projects you shop the most.",
        },
        qualified: {
            titleDesktop: {
                line1: "Start Saving with Preferred Pricing",
                line2: "You've Unlocked Savings with Pro Xtra Preferred Pricing.",
            },
            titleMobile: {
                line1: "Start Saving with",
                line2: "PREFERRED PRICING",
            },
            content1: "How Does It Work?",
            content2: "Learn More",
        },
    },
    ppBlurbs: {
        virtualID: {
            title: { line1: "Scan Your Virtual ID to Unlock Preferred Pricing" },
            content: {
                line1: "Unlock Preferred Pricing by simply using your Virtual ID in-store when you shop. You'll be notified on the Program Details screen once you've been awarded.",
            },
        },
        shopScanSave: {
            title: { line1: "Shop, Scan and Save" },
            content: {
                line1: "Now you can discover a wide range of savings in-store by scanning items with the Home Depot app. Just scan eligible items and look for the Preferred Pricing icon on the item's details page.",
            },
        },
        projectPriority: {
            title: { line1: "Your Projects Are Our Priority" },
            content: {
                line1: "Preferred Pricing brings you savings from start to finish. Look for the Preferred Pricing symbol in-store and online - everywhere you shop the products you buy most for your projects.",
            },
        },
        savingsThatGrow: {
            title: { line1: "Savings That Grow As You Spend" },
            content: {
                line1: "As you continue to shop with Pro Xtra, you'll see even greater savings with Preferred Pricing.",
                line2: "Unlock the next tier and unlock more value.",
            },
        },
        unlockPrefPricing: {
            title: { line1: "Get Qualified for Preferred Pricing" },
            content: {
                line1: "Your spend is what helps you reach the next tier and qualify for additional benefits. Just scan your Virtual ID for all in-store purchases and get credit towards unlocking Preferred Pricing.",
            },
        },
    },
    ppBlurbsHDPass: {
        virtualID: {
            title: { line1: "Scan Your HD Pass to Unlock Preferred Pricing" },
            content: {
                line1: "Unlock Preferred Pricing by simply using your HD Pass in-store when you shop. You'll be notified on the Program Details screen once you've been awarded.",
            },
        },
        shopScanSave: {
            title: { line1: "Shop, Scan and Save" },
            content: {
                line1: "Now you can discover a wide range of savings in-store by scanning items with the Home Depot app. Just scan eligible items and look for the Preferred Pricing icon on the item's details page.",
            },
        },
        projectPriority: {
            title: { line1: "Your Projects Are Our Priority" },
            content: {
                line1: "Preferred Pricing brings you savings from start to finish. Look for the Preferred Pricing symbol in-store and online - everywhere you shop the products you buy most for your projects.",
            },
        },
        savingsThatGrow: {
            title: { line1: "Savings That Grow As You Spend" },
            content: {
                line1: "As you continue to shop with Pro Xtra, you'll see even greater savings with Preferred Pricing.",
                line2: "Unlock the next tier and unlock more value.",
            },
        },
        unlockPrefPricing: {
            title: { line1: "Get Qualified for Preferred Pricing" },
            content: {
                line1: "Your spend is what helps you reach the next tier and qualify for additional benefits. Just scan your HD Pass for all in-store purchases and get credit towards unlocking Preferred Pricing.",
            },
        },
    },
    modallist: [
        {
            id: 1,
            name: "Shop to unlock more savings",
            description: "Shop for all of your project supplies in-store or online to unlock even deeper savings.",
            imgurl: assetsPricing.hdiwPlaceholder,
        },
        {
            id: 2,
            name: "Use Product Scan in the app to see pricing while in-store",
            description: "Need a price check? Use the product scan feature in the app to see your Preferred Pricing on all eligible project items.",
            imgurl: assetsPricing.hdiwShopInStore,
        },
        {
            id: 3,
            name: "Shop In-store, then scan your Virtual ID",
            description: "Ready to checkout? Make sure to scan your Pro Xtra Virtual ID at the kiosk to apply Preferred Pricing savings and track purchases.",
            imgurl: assetsPricing.hdiwScanId,
        },
        {
            id: 4,
            name: "Save with Preferred Pricing online",
            description: "Look for Preferred Pricing on product pages and in-cart as you shop online or with the Home Depot App and see your savings at checkout.",
            imgurl: assetsPricing.hdiwShopOnline,
        },
        {
            id: 5,
            name: "See how Preferred Pricing works.",
            description: "Watch the video to learn more about Preferred Pricing and start unlocking savings today.",
            imgurl: assetsPricing.proXtraPreferredD,
        },
    ],
};
export var pbNationalAccount = {
    modalAgreementDescription1: "As a member of Pro Xtra and a participating National Association or Affiliation, you are eligible for exclusive benefits at The Home Depot.",
    modalAgreementDescription2: "If your organization has provided you with a National Agreement Code, you can enroll now.",
    modalToolTip: "Note: this is not a promo code.",
    agreementCode: "Agreement Code",
    renderEinDesc1: "As a member of Government Affiliation, you are required to enter your federally-issued Employer Identification Number (EIN).",
    note: "Note:",
    name: "Name:",
    code: "Code:",
    continueText: "Continue",
    cancelText: "Cancel",
    closeText: "Close",
    enrollText: "Enroll",
    unEnrollText1: "Yes, Unenroll",
    unEnrollText2: "Unenroll",
    unEnrollText3: "Wait! Keep it",
    unEnrollText4: "Keep it",
    enrollmentDate: "Enrollment Date:",
    validateCodeText: "Validate Code",
    validateIncentivesText: "National Account Incentives",
    unenrollIncentives: "Unenroll from Account Incentives",
    unenrollConfirmation: "Unenrollment Confirmation",
    unenrollConfirmation3: "You have been unenrolled from National Account Incentives.",
    unenrollConfirmation4: "If you have been given a new National Agreement Code you may enroll at any time.",
    validateAgreementCodeText: "Valid Agreement Code",
    unenrollConfirmation1: " Are you sure you want to unenroll from the National Rebate below?",
    unenrollConfirmation2: " Are you sure you want to unenroll from the National Account Incentives Program below?",
    noteText: "By clicking Enroll below you will also be unenrolled from Pro Xtra Perks, if currently enrolled.",
    GovernmentAffiliationText1: "Government & municipal customers who purchase under this Affiliation are ineligible to receive Pro Xtra Perks:",
    GovernmentAffiliationText5: "You will no longer have access to any Perks earned.",
    GovernmentAffiliationText2: "You will be unenrolled from Pro Xtra Perks, if currently enrolled.",
    GovernmentAffiliationText3: "If desired, please use available Perks before joining this Government Affiliation.",
    GovernmentAffiliationText4: "Please select to acknowledge that you will be unenrolled from Pro Xtra Perks.",
    nationalAccountsText: "Members of Pro Xtra and participating National Accounts and Affiliations may qualify for additional benefits.",
    termsAndConditionsText: ["National Account Incentives", "Terms & Conditions"],
    agreementDescriptionText1: " Members of Pro Xtra and participating National Accounts and Affiliations may qualify for additional benefits.",
    agreementDescriptionText2: " All forms of payment accepted at The Home Depot can be saved to your account on the",
    agreementDescriptionText3: "Qualifying purchases can be made both online and in-store using a registered payment method",
    agreementDescriptionEINNote: "Government and municipal customers who purchase from The Home Depot under the U.S. Communities (now Omnia Partners, Public Sector) Government Purchasing Alliance, or other government contracts, are ineligible to receive Pro Xtra Perks.",
};
